export default __webpack_public_path__ + "static/media/advanced-mine.47f37071.svg";